module.exports = __webpack_public_path__ + "static/media/plus.5730b6f2.svg";